module.exports = __webpack_public_path__ + "0bb6b734d9509e2bba53ea27c847d282.pdf";